module.exports = __webpack_public_path__ + "static/media/MOB.e2dbb24b.png";